"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.PriceAndButton = exports.Price = exports.Inner = exports.Info = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const Root = exports.Root = (0, _mui.styled)('a', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  theme,
  isClickable
}) => ({
  display: 'flex',
  padding: theme.spacing(2, 0),
  gap: theme.spacing(3),
  cursor: isClickable ? 'pointer' : 'auto'
}));
const Inner = exports.Inner = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  width: '100%',
  flexDirection: 'column',
  gap: theme.spacing(2),
  ...(theme.responsiveLayout && {
    [theme.breakpoints.up('lg')]: {
      flexDirection: 'row',
      height: 'min-content',
      alignItems: 'center'
    }
  })
}));
const Info = exports.Info = (0, _mui.styled)('div')(({
  theme
}) => ({
  ...(theme.responsiveLayout && {
    [theme.breakpoints.up('md')]: {
      flex: 3
    }
  })
}));
const PriceAndButton = exports.PriceAndButton = (0, _mui.styled)('div')(({
  theme
}) => ({
  width: '100%',
  display: 'flex',
  gap: theme.spacing(2),
  ...(theme.responsiveLayout && {
    [theme.breakpoints.up('md')]: {
      flex: 2
    }
  })
}));
const Price = exports.Price = (0, _mui.styled)('div')(({
  theme
}) => ({
  flex: '1 1 0',
  ...(theme.responsiveLayout && {
    [theme.breakpoints.up('lg')]: {
      display: 'flex',
      alignItems: 'center'
    }
  })
}));
//# sourceMappingURL=styles.js.map